import { ApplicationState } from '../index';
import {
    KnownTenants,
    TenantBasicSettings,
    TenantFlowDisabledContent,
    TenantLoginText,
} from './Actions';
import { BrandConfig } from './Reducer';

import {
    BannerMessage,
    PortalSafeDataCollectionLimitResponse,
    TenantUserMetadataSetting
} from '../../Models/Api/strongbox.financialportal';

export function GetTenantName(state: ApplicationState): string {
    return (state && state.tenant && state.tenant.tenantName) || KnownTenants.strongbox;
}

export function GetTenantNameId(state: ApplicationState): string {
    return (state && state.tenant && state.tenant.tenantNameId) || KnownTenants.strongbox;
}

export function GetBasicSettings(state: ApplicationState): TenantBasicSettings | undefined {
    return (state && state.tenant && state.tenant.basicSettings);
}

export function GetBrandConfig(state: ApplicationState): BrandConfig {
    return (state && state.tenant && state.tenant.brandConfig);
}

export function IsLenderDisabled(state: ApplicationState): boolean {
    return (
        !!state &&
        !!state.tenant &&
        !!state.tenant.basicSettings &&
        !!state.tenant.basicSettings.tenantDisable &&
        !!state.tenant.basicSettings.tenantDisable.lender
    );
}

export function IsBorrowerDisabled(state: ApplicationState): boolean {
    return (
        !!state &&
        !!state.tenant &&
        !!state.tenant.basicSettings &&
        !!state.tenant.basicSettings.tenantDisable &&
        !!state.tenant.basicSettings.tenantDisable.borrower
    );
}

export function GetLenderDisabledContent(state: ApplicationState): TenantFlowDisabledContent | undefined {
    if (!(state && state.tenant && state.tenant.basicSettings && state.tenant.basicSettings.tenantDisable)) {
        return undefined;
    }
    return state.tenant.basicSettings.tenantDisable.lender;
}

export function GetBorrowerDisabledContent(state: ApplicationState): TenantFlowDisabledContent | undefined {
    if (!(state && state.tenant && state.tenant.basicSettings && state.tenant.basicSettings.tenantDisable)) {
        return undefined;
    }
    return state.tenant.basicSettings.tenantDisable.borrower;
}

export function GetTenantLoginTextStyle(loginText: TenantLoginText): React.CSSProperties {
    let style: React.CSSProperties = {}

    if (loginText.bold) {
        style['fontWeight'] = 'bold';
    }
    if (!!loginText.fontSize) {
        style['fontSize'] = `${loginText.fontSize}px`;
    }
    if (!!loginText.bottomMargin) {
        style['marginBottom'] = `${loginText.bottomMargin}px`;
    }
    return style;
}

export function GetEmailDomains(state: ApplicationState): string[] {
    if (!(state && state.tenant)) {
        return [];
    }
    return state.tenant.emailDomains;
}

export function GetUserMetadataSettings(state: ApplicationState): TenantUserMetadataSetting[] {
    if (!(state && state.tenant)) {
        return [];
    }
    return state.tenant.userMetadataSettings;
}

export function GetBannerMessages(state: ApplicationState): BannerMessage[] {
    if (!(state && state.tenant)) {
        return [];
    }
    return state.tenant.bannerMessages;
}

export function GetDataCollectionLimits(state: ApplicationState): PortalSafeDataCollectionLimitResponse | undefined {
    if (!(state && state.tenant)) {
        return undefined;
    }
    return state.tenant.dataCollectionLimits;
}

/// Is the secific tenant feature switch enabled on the current consumer.  This is specifically
/// not 'Enabled' because some switch Id's are named as 'disable'.
///
/// Returns true if the switch is true.  if the switch is not found configured for this tenant the 
/// return value is false.

export function IsTenantFeatureSwitchOn(state: ApplicationState, switchNameId: string): boolean {
    if (!(state && state.tenant && state.tenant.featureSwitches && state.tenant.featureSwitches.featureSwitches)) {
        return false;
    }
    const key = switchNameId.toLowerCase();
    const featureSwitch = state.tenant.featureSwitches.featureSwitches.find(s => s.featureSwitchNameId.toLowerCase() === key);
    return !!featureSwitch && featureSwitch.value;
}